module.exports = __webpack_public_path__ + "img/about-page5-img-3.f4678b05.jpg";